export default {
  modals: {
    delete_payment_method: {
      title: 'Haluatko varmasti poistaa tämän maksutavan?',
    },
  },
  buttons: {
    confirm: 'Vahvista',
    cancel: 'Peruuta',
  },
  toasts: {
    failed_to_delete_payment_method: 'Maksutavan poistaminen epäonnistui',
    payment_method_deleted: 'Maksutapa poistettiin',
  },
};
